module.exports = __webpack_public_path__ + "img/shin4.c6ed0803.jpg";